'use strict';

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    onClick: PropTypes.func,
};

const defaultProps = {
}

function AvatarButton(props) {
    const charImages = MZLAvatarLibrary.getPlayerHashes();
    const userAvatar = MZLAvatarLibrary.getAvatar(props.userInfo.avatar_hash) || MZLAvatarLibrary.getDefaultAvatar();
    const avatarName = props.userInfo.avatar_name || props.userInfo.display_name || props.userInfo.first_name;
    return (
        <button className='avatar-button' onClick={props.onClick}>
            <img src={userAvatar.src} alt="Avatar Image" aria-hidden={true}/>
            <span>{avatarName}</span>
        </button>
    );
}

AvatarButton.propTypes = propTypes;
AvatarButton.defaultProps = defaultProps;

export default AvatarButton;